import React from "react";
import { Header } from "../Components/helpCenter/Header";
import { Faq } from "../Components/helpCenter/Faq";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export const HelpCenter = () => {
    const { t } = useTranslation();

    const faqData = [
    {
        id: 1,
        question: t("faqQ1"),
        answer: t("faqA1")
    },
    {
        id: 2,
        question: t("faqQ2"),
        answer: t("faqA2")
    },
    {
        id: 3,
        question: t("faqQ3"),
        answer: t("faqA3")
    },
    {
        id: 4,
        question: t("faqQ4"),
        answer: t("faqA4")
    },
    {
        id: 5,
        question: t("faqQ5"),
        answer: t("faqA5")
    },
    {
        id: 6,
        question: t("faqQ6"),
        answer: t("faqA6")
    },
    {
        id: 7,
        question: t("faqQ7"),
        answer: t("faqA7")
    },
    {
        id: 8,
        question: t("faqQ8"),
        answer: t("faqA8")
    },
    {
        id: 9,
        question: t("faqQ9"),
        answer: t("faqA9")
    },
    {
        id: 10,
        question: t("faqQ10"),
        answer: t("faqA10")
    },
    {
        id: 11,
        question: t("faqQ11"),
        answer: t("faqA11")
    },
    {
        id: 12,
        question: t("faqQ12"),
        answer: t("faqA12")
    }
];

const openMatchFAQData = [
    {
        id: 1,
        question: t("openMatchQ1"),
        answer: t("openMatchA1")
    },
    {
        id: 2,
        question: t("openMatchQ2"),
        answer: t("openMatchA2")
    },
    {
        id: 3,
        question: t("openMatchQ3"),
        answer: t("openMatchA3")
    },
    {
        id: 4,
        question: t("openMatchQ4"),
        answer: t("openMatchA4")
    }
];

    return (
        <div>
            <Helmet>
                <title>{t("Title.helpCenter")} | Padel Mates</title>
            </Helmet>
            <Header />
            <Faq
                title={t("faq")}
                subtitle={t("faqProvidesAnswers")}
                data={faqData}
            />
            <div className="-mt-12">
                <Faq
                    title={t("faqOpenMatchRules")}
                    subtitle={t("pleaseReadCarefully")}
                    data={openMatchFAQData}
                />
            </div>
            <div className="flex flex-col gap-4 text-secondary items-center justify-center max-w-[1450px] mx-auto md:px-8 px-4 mb-10 -mt-20">
                <p>
                    {t("additionalQuestions")}
                </p>
            </div>
        </div>
    );
};
